import { webApiService } from '@/services'
import { useEffect, useMemo, useState } from 'react'

export interface IBatteryModel {
  brand: string
  model: string
}

/* Sin acentos, en minúscula y con los espacios colapsados: el catálogo y el tradein no
   siempre escriben igual la misma marca/modelo. */
const normalize = (value: string): string => value
  .normalize('NFD')
  .replace(/[\u0300-\u036f]/g, '')
  .toLowerCase()
  .replace(/\s+/g, ' ')
  .trim()

export const useBatteryModelSupport = (brand: string, model: string) => {
  const [data, setData] = useState<{ loading: boolean, list: IBatteryModel[] }>({ loading: true, list: [] })

  useEffect(() => {
    let active = true

    webApiService.getModelBatteryList()
      .then((res) => {
        if (!active) return
        setData({ loading: false, list: Array.isArray(res.data) ? res.data : [] })
      })
      .catch((error) => {
        console.log('Error cargando el catálogo de modelos con batería:', error)
        if (!active) return
        setData({ loading: false, list: [] })
      })

    return () => { active = false }
  }, [])

  const isBatteryModelSupported = useMemo(() => {
    const brandKey = normalize(brand ?? '')
    const modelKey = normalize(model ?? '')
    if (brandKey === '' || modelKey === '') return false

    return data.list.some((item) => {
      const catalogModel = normalize(item.model ?? '')
      /* modelo vacío en el catálogo se ignora: includes('') haría match con cualquier cosa */
      if (catalogModel === '') return false
      return normalize(item.brand ?? '') === brandKey && modelKey.includes(catalogModel)
    })
  }, [data.list, brand, model])

  return { loadingBatteryModels: data.loading, isBatteryModelSupported }
}
